import ElementEnLoc from 'element-ui/lib/locale/lang/en'
import ElementZhLoc from 'element-ui/lib/locale/lang/zh-CN'
const locales = {
  en: require('../locale/en.json'),
  zh:  require('../locale/zh.json')
}

locales.en = { ...locales.en, ...ElementEnLoc }
locales.zh = { ...locales.zh, ...ElementZhLoc }

export default locales
